import MainRoutes from "./Routes/MainRoutes";
import "./sass/App.scss";

function App() {
  return (
    <div>
      <MainRoutes />
    </div>
  );
}

export default App;
